import { ERROR_PHOTO_NEEDED, missionImageField } from '../../../../utils/constants'

export default (page, { answer = {} }) => {
  const has_answer = answer[missionImageField(page)]
  return {
    valid: !!has_answer,
    is_correct_answer: true,
    errors: has_answer ? new Set() : new Set([
      ERROR_PHOTO_NEEDED,
    ]),
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/photo.jsx